import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOnlineApprovalTimeEntry } from '../models/online-approval-time-entry.model';
import cloneDeep from 'lodash/cloneDeep';

class TimeEntriesState {
    originalTimeEntries: IOnlineApprovalTimeEntry[];
    selectedTimesheetTimeEntries: IOnlineApprovalTimeEntry[];
    changedTimeEntries: IOnlineApprovalTimeEntry[];
}

const timeEntriesSlice = createSlice({
    name: 'timeEntries',
    initialState: {
        originalTimeEntries: [],
        selectedTimesheetTimeEntries: [],
        changedTimeEntries: [],
    },
    reducers: {
        setTimeEntries(state: TimeEntriesState, action: PayloadAction<IOnlineApprovalTimeEntry[]>) {
            state.originalTimeEntries = action.payload;

            // selectedTimesheetTimeEntries must contain DEEP copies of each member
            // of originalTimeEntries in order for change detection to work, so the
            // spread operator cannot be used here:
            state.selectedTimesheetTimeEntries = cloneDeep(action.payload);
        },

        setSelectedTimesheetTimeEntries(state: TimeEntriesState, action: PayloadAction<IOnlineApprovalTimeEntry[]>) {
            state.selectedTimesheetTimeEntries = action.payload;
        },

        setChangedTimeEntries(state: TimeEntriesState, action: PayloadAction<IOnlineApprovalTimeEntry>) {
            const { changedTimeEntries = [] } = state;
            const { payload } = action;

            const index = state.changedTimeEntries?.findIndex(
                (timeEntry: IOnlineApprovalTimeEntry) => timeEntry.id === payload.id,
            );

            if (index !== -1) {
                state.changedTimeEntries[index] = payload;
            } else {
                state.changedTimeEntries?.push(payload);
                state.selectedTimesheetTimeEntries?.push(payload);
            }

            state.changedTimeEntries = changedTimeEntries;
        },

        clearChangedTimeEntries(state: TimeEntriesState) {
            state.changedTimeEntries = [];
        },
    },
});

export const {
    setTimeEntries,
    setSelectedTimesheetTimeEntries,
    setChangedTimeEntries,
    clearChangedTimeEntries,
} = timeEntriesSlice.actions;

export default timeEntriesSlice.reducer;
